module.exports = __webpack_public_path__ + "img/QQlogo.f0ac2cf5.png";